import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPedalAccelerator = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M33.518 6.5h32.95c6.096 0 10.993 4.949 11.003 11.095l.075 47.039c.01 6.202-5.643 12.154-8.458 15.911l-9.757 13.02c-1.685 2.249-3.413 3.935-8.49 3.935H33.443c-6.096 0-11.01-4.949-11.003-11.095l.074-68.81C22.521 11.448 27.422 6.5 33.517 6.5z" })
});
export default SvgPedalAccelerator;
